import GInput from './GInput.vue';

export default GInput;

export { GInput };
